import React, { useState, useEffect } from "react";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={styles.banner}>
      <p style={styles.text}>
        Używamy plików cookies, aby zapewnić najlepsze doświadczenia na naszej
        stronie.{" "}
        <a href="/polityka-prywatnosci" style={styles.link}>
          Dowiedz się więcej
        </a>
      </p>
      <button onClick={acceptCookies} style={styles.button}>
        OK
      </button>
    </div>
  );
};

const styles = {
  banner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    background: "#2e2e2d",
    color: "#fff",
    padding: "12px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    flexWrap: "wrap",
    zIndex: 9999,
    fontSize: "14px",
    boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
  },
  text: {
    margin: 0,
    textAlign: "center",
  },
  link: {
    color: "#db5c00",
    textDecoration: "underline",
  },
  button: {
    background: "#db5c00",
    color: "#fff",
    border: "none",
    padding: "8px 24px",
    borderRadius: "20px",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: "14px",
    transition: "background 0.2s",
  },
};

export default CookieBanner;
